import { stripHTML } from "./htmlStringUtils";

export const countWords = text => {
  if (!text) return 0;

  return stripHTML(text)
    .trim()
    .split(/\s+/)
    .filter(word => word.length > 0).length;
};
